module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-5-2x-bc170faebb43de630703071cc640fa2a.jpg";